<fieldset class="sps-fieldset form-data-container separator">
  <div class="grid w-full">
    <div class="col-12 flex flex-column gap-2">
      <div class="flex flex-column gap-2 w-full">
        <label for="link-status">{{ i18n.i18nLng()['ACTIVATIONSTATUS'] }}</label>
      </div>
      <div class="flex align-items-center gap-2">
        <p-toggleswitch [(ngModel)]="paymentData.active"/>
        <span class="text-lg">{{ i18n.i18nLng()['ACTIVE'] }}</span>
      </div>
    </div>
    <div class="col-6 flex flex-column gap-2">
      <label for="provider">{{ i18n.i18nLng()['PROVIDER'] }}</label>
      <input pInputText
             id="provider"
             [(ngModel)]="paymentData.provider"
             [disabled]="true"
             pSize="large"/>
    </div>
    <div class="col-6 flex flex-column gap-2">
      <label for="acquirer">{{ i18n.i18nLng()['ACQUIRER'] }}</label>
      <input pInputText
             id="acquirer"
             [(ngModel)]="paymentData.acquirer"
             [disabled]="true"
             pSize="large"/>
    </div>
    <div class="col-6 flex flex-column gap-2">
      <label for="merchant-id">
        {{ i18n.i18nLng()['PSPMERCHANTID'] }}
        @if (paymentData.active) {
          <sup class="sps-sup">*</sup>
        }
      </label>
      <input pInputText
             [pAutoFocus]="true"
             id="merchant-id"
             maxlength="100"
             [(ngModel)]="paymentData.pspMerchantId"
             [required]="paymentData.active"
             [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
             [ngClass]="paymentInvalidFlags?.pspMerchantId ? 'ng-invalid ng-dirty' : null"
             [attr.aria-invalid]="paymentInvalidFlags?.pspMerchantId"
             [attr.aria-describedby]="paymentInvalidFlags?.pspMerchantId ? 'merchant-id-invalid-help' : null"
             pSize="large"/>
      @if (paymentInvalidFlags?.pspMerchantId) {
        <small style="line-height: 1.5rem" class="text-error" role="alert" id="merchant-id-invalid-help">{{ i18n.i18nLng()['REQUIREDHELP'] }}</small>
      }
    </div>
    @if ( paymentData.paymentMethod === PaymentMethodName.CREDITCARD ||
          paymentData.paymentMethod === PaymentMethodName.CREDITCARD_MOTO ||
          paymentData.paymentMethod === PaymentMethodName.APPLEPAY ||
          paymentData.paymentMethod === PaymentMethodName.GOOGLEPAY) {
      <div class="col-6 flex flex-column gap-2">
        <label for="vu-number">
          {{ i18n.i18nLng()['VUNUMBER'] }}
          @if (paymentData.active) {
            <sup class="sps-sup">*</sup>
          }
        </label>
        <input pInputText
               id="vu-number"
               maxlength="10"
               [(ngModel)]="paymentData.vuNumber"
               [required]="paymentData.active"
               [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
               [ngClass]="paymentInvalidFlags?.vuNumber ? 'ng-invalid ng-dirty' : null"
               [attr.aria-invalid]="paymentInvalidFlags?.vuNumber"
               [attr.aria-describedby]="paymentInvalidFlags?.vuNumber ? 'vu-number-invalid-help' : null"
               pSize="large"/>
        @if (paymentInvalidFlags?.vuNumber) {
          <small style="line-height: 1.5rem" class="text-error" role="alert" id="vu-number-invalid-help">{{ i18n.i18nLng()['REQUIREDHELP'] }}</small>
        }
      </div>
    }
    @if ( (paymentData.paymentMethod === PaymentMethodName.CREDITCARD ||
          paymentData.paymentMethod === PaymentMethodName.CREDITCARD_MOTO ||
          paymentData.paymentMethod === PaymentMethodName.SEPA ||
          paymentData.paymentMethod === PaymentMethodName.SEPA_BLACKLIST ||
          paymentData.paymentMethod === PaymentMethodName.PAYPAL ||
          paymentData.paymentMethod === PaymentMethodName.APPLEPAY ||
          paymentData.paymentMethod === PaymentMethodName.GOOGLEPAY)
          && !paymentData.isChargebackCard) {
      <div class="col-6 flex flex-column gap-2 justify-content-end">
        <div class="flex align-items-center">
          <p-checkbox inputId="auth-enabled"
                      [(ngModel)]="paymentData.authorizationEnabled"
                      [binary]="true"
                      size="large"/>
          <label for="auth-enabled" class="ml-2 text-lg">{{ i18n.i18nLng()['AUTHORIZATIONENABLED'] }}</label>
        </div>
      </div>
    }
    @if (paymentData.paymentMethod !== PaymentMethodName.DIRECTTRANSFER && !paymentData.isChargebackCard && !(paymentData.paymentMethod === PaymentMethodName.CREDITCARD && customerGroup == CustomerGroup.SID)) {
      <div class="col-6 flex flex-column gap-2 justify-content-end">
        <div class="flex align-items-center">
          <p-checkbox inputId="refunds-enabled"
                      [(ngModel)]="paymentData.refundsEnabled"
                      [binary]="true"
                      size="large"/>
          <label for="refunds-enabled" class="ml-2 text-lg">{{ i18n.i18nLng()['REFUNDSENABLED'] }}</label>
        </div>
      </div>
    }
    @if ((paymentData.paymentMethod === PaymentMethodName.CREDITCARD && !paymentData.isChargebackCard) && (customerGroup === CustomerGroup.SID)) {
      <div class="col-6 flex flex-column gap-2 justify-content-end">
        <div class="flex align-items-center">
          <p-checkbox inputId="credits-enabled"
                      [(ngModel)]="paymentData.creditEnabled"
                      (onChange)="onCreditCardEnabledChanged($event.checked)"
                      [binary]="true"
                      size="large"/>
          <label for="credit-enabled" class="ml-2 text-lg">{{ i18n.i18nLng()['CREDITSENABLED'] }}</label>
        </div>
      </div>
      @if (paymentData.creditEnabled) {
        <div class="col-6 flex flex-column gap-2">
          <label for="chargebach-card">
            {{ i18n.i18nLng()['CHARGEBACKREFERENCECARD'] }}
          </label>
          <p-select [(ngModel)]="paymentData.chargebackProjectId"
                    inputId="cardbrand"
                    [options]="chargebackCards"
                    [showClear]="false"
                    [placeholder]="i18n.i18nLng()['PLACEHOLDERSELECT']"
                    optionLabel="label"
                    optionValue="value"
                    class="w-full"
                    size="large"
                    appendTo="body"
                    [attr.aria-label]="i18n.i18nLng()['CHARGEBACKREFERENCECARD']">
          </p-select>
        </div>
      }
    }
  </div>
</fieldset>
@if (paymentData.paymentMethod === PaymentMethodName.WERO) {
  <fieldset class="sps-fieldset form-data-container separator pt-3">
    <div class="grid w-full">
      <div class="col-6 flex flex-column gap-2">
        <label for="api-client-key">
          {{ i18n.i18nLng()['APICLIENTKEY'] }}
          @if (paymentData.active) {
            <sup class="sps-sup">*</sup>
          }
        </label>
        <input pInputText
               id="api-client-key"
               maxlength="20"
               [(ngModel)]="paymentData.apiClientKey"
               [required]="paymentData.active"
               [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
               [ngClass]="paymentInvalidFlags?.apiClientKey ? 'ng-invalid ng-dirty' : null"
               [attr.aria-invalid]="paymentInvalidFlags?.apiClientKey"
               [attr.aria-describedby]="paymentInvalidFlags?.apiClientKey ? 'api-client-key-invalid-help' : null"
               pSize="large"/>
        @if (paymentInvalidFlags?.apiClientKey) {
          <small style="line-height: 1.5rem" class="text-error" role="alert" id="api-client-key-invalid-help">{{ i18n.i18nLng()['REQUIREDHELP'] }}</small>
        }
      </div>
      <div class="col-6 flex flex-column gap-2">
        <label for="api-client-secret">
          {{ i18n.i18nLng()['APICLIENTSECRET'] }}
          @if (paymentData.active) {
            <sup class="sps-sup">*</sup>
          }
        </label>
        <input pInputText
               id="api-client-secret"
               maxlength="128"
               [(ngModel)]="paymentData.apiClientSecret"
               [required]="paymentData.active"
               [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
               [ngClass]="paymentInvalidFlags?.apiClientSecret ? 'ng-invalid ng-dirty' : null"
               [attr.aria-invalid]="paymentInvalidFlags?.apiClientSecret"
               [attr.aria-describedby]="paymentInvalidFlags?.apiClientSecret ? 'api-client-secret-invalid-help' : null"
               pSize="large"/>
        @if (paymentInvalidFlags?.apiClientSecret) {
          <small style="line-height: 1.5rem" class="text-error" role="alert" id="api-client-secret-invalid-help">{{ i18n.i18nLng()['REQUIREDHELP'] }}</small>
        }
      </div>
      <div class="col-6 flex flex-column gap-2">
        <label for="webhook-key">
          {{ i18n.i18nLng()['WEBHOOKKEY'] }}
        </label>
          <!-- Sobald alle webhook-Daten verfügbar sind und kein polling mehr erfolgt, diesen Input verwenden -->
          <!--
            @if (paymentData.active) {
              <sup class="sps-sup">*</sup>
            }
          </label>
          <input pInputText
                 id="webhook-key"
                 maxlength="40"
                 [(ngModel)]="paymentData.webhookKey"
                 [required]="paymentData.active"
                 [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
                 [ngClass]="paymentInvalidFlags?.webhookKey ? 'ng-invalid ng-dirty' : null"
                 [attr.aria-invalid]="paymentInvalidFlags?.webhookKey"
                 [attr.aria-describedby]="paymentInvalidFlags?.webhookKey ? 'webhook-key-invalid-help' : null"
                 pSize="large"/>
          @if (paymentInvalidFlags?.webhookKey) {
            <small style="line-height: 1.5rem" class="text-error" role="alert" id="webhook-key-invalid-help">{{ i18n.i18nLng()['REQUIREDHELP'] }}</small>
          }
          -->
        <input pInputText
               id="webhook-key"
               maxlength="40"
               [(ngModel)]="paymentData.webhookKey"
               [required]="false"
               [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
               pSize="large"/>
      </div>
      <div class="col-6 flex flex-column gap-2">
        <label for="webhook-secret">
          {{ i18n.i18nLng()['WEBHOOKSECRET'] }}
        </label>
          <!-- Sobald alle webhook-Daten verfügbar sind und kein polling mehr erfolgt, diesen Input verwenden -->
          <!--
            @if (paymentData.active) {
              <sup class="sps-sup">*</sup>
            }
          </label>
          <input pInputText
                 id="webhook-secret"
                 maxlength="128"
                 [(ngModel)]="paymentData.webhookSecret"
                 [required]="paymentData.active"
                 [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
                 [ngClass]="paymentInvalidFlags?.webhookSecret ? 'ng-invalid ng-dirty' : null"
                 [attr.aria-invalid]="paymentInvalidFlags?.webhookSecret"
                 [attr.aria-describedby]="paymentInvalidFlags?.webhookSecret ? 'webhook-secret-invalid-help' : null"
                 pSize="large"/>
          @if (paymentInvalidFlags?.webhookSecret) {
            <small style="line-height: 1.5rem" class="text-error" role="alert" id="webhook-secret-invalid-help">{{ i18n.i18nLng()['REQUIREDHELP'] }}</small>
          }
          -->
          <input pInputText
                 id="webhook-secret"
                 maxlength="128"
                 [(ngModel)]="paymentData.webhookSecret"
                 [required]="false"
                 [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
                 pSize="large"/>
        </div>
        <div class="col-6 flex flex-column gap-2">
          <label for="payone-partner-id">
            {{ i18n.i18nLng()['PAYONEPARTNERID'] }}
          </label>
          <input pInputText
                 id="payone-partner-id"
                 maxlength="7"
                 [(ngModel)]="paymentData.payOnePartnerId"
                 (ngModelChange)="checkForEmptyPartnerId()"
                 [required]="false"
                 [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
                 [ngClass]="paymentInvalidFlags?.payOnePartnerId ? 'ng-invalid ng-dirty' : null"
                 [attr.aria-invalid]="paymentInvalidFlags?.payOnePartnerId"
                 [attr.aria-describedby]="paymentInvalidFlags?.payOnePartnerId ? 'api-payone-id-invalid-help' : null"
                 pSize="large"/>
          @if (paymentInvalidFlags?.payOnePartnerId) {
            <small style="line-height: 1.5rem" class="text-error" role="alert" id="api-payone-id-invalid-help">{{ i18n.i18nLng()['PAYONEIDHELP'] }}</small>
          }
        </div>
      </div>
    </fieldset>
  }
  @if (paymentData.paymentMethod === PaymentMethodName.PAYPAL) {
    <fieldset class="sps-fieldset form-data-container separator pt-3">
      <div class="grid w-full">
        <div class="col-6 flex flex-column gap-2">
          <label for="paypal-email">{{ i18n.i18nLng()['PAYPALEMAIL'] }}
            @if (paymentData?.active) {
              <sup class="sps-sup">*</sup>
            }
          </label>
          <input pInputText
                 id="paypal-email"
                 maxlength="255"
                 [(ngModel)]="paymentData.payPalEmailAddress"
                 [required]="paymentData?.active"
                 [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
                 [ngClass]="paymentInvalidFlags?.payPalEmailAddress ? 'ng-invalid ng-dirty' : null"
                 [attr.aria-invalid]="paymentInvalidFlags?.payPalEmailAddress"
                 [attr.aria-describedby]="paymentInvalidFlags?.payPalEmailAddress ? 'email-invalid-help' : null"
                 pSize="large"/>
          @if (paymentInvalidFlags?.payPalEmailAddress) {
            <small style="line-height: 1.5rem" class="text-error" role="alert" id="email-invalid-help">{{ i18n.i18nLng()['REQUIREDHELP'] }}</small>
          } @else {
            @if (paymentInvalidFlags.invalidEmailFormat) {
              <small style="line-height: 1.5rem" class="text-error" role="alert" id="email-invalid-help">{{ i18n.i18nLng()['INVALIDEMAILINFO'] }}</small>
            }
          }
        </div>
        <div class="col-6 flex flex-column gap-2">
          <label for="paypal-customer-id">
            {{ i18n.i18nLng()['PAYPALMERCHANTID'] }}</label>
          <input pInputText
                 id="paypal-customer-id"
                 maxlength="50"
                 [(ngModel)]="paymentData.payPalMerchantId"
                 [required]="false"
                 [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
                 pSize="large"/>
        </div>
      </div>
    </fieldset>
  }
  @if (paymentData.paymentMethod === PaymentMethodName.GOOGLEPAY) {
    <fieldset class="sps-fieldset form-data-container separator pt-3">
      <div class="grid w-full">
        <div class="col-6 flex flex-column gap-2">
          <label for="google-customer-id">
            {{ i18n.i18nLng()['GOOGLEPAYMERCHANTID'] }}
            @if (paymentData.active) {
              <sup class="sps-sup">*</sup>
            }
          </label>
          <input pInputText
                 id="google-customer-id"
                 maxlength="16"
                 [(ngModel)]="paymentData.googlePayMerchantId"
                 [required]="paymentData.active"
                 [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
                 [ngClass]="paymentInvalidFlags?.googlePayMerchantId ? 'ng-invalid ng-dirty' : null"
                 [attr.aria-invalid]="paymentInvalidFlags?.googlePayMerchantId"
                 [attr.aria-describedby]="paymentInvalidFlags?.googlePayMerchantId ? 'gpay-merchant-id-invalid-help' : null"
                 pSize="large"/>
          @if (paymentInvalidFlags?.googlePayMerchantId) {
            <small style="line-height: 1.5rem" class="text-error" role="alert" id="gpay-merchant-id-invalid-help">{{ i18n.i18nLng()['REQUIREDHELP'] }}</small>
          }
        </div>
      </div>
    </fieldset>
  }
